import BaseLineupValidatorBuilder from 'services/sports/default/base-lineup-validator-builder';

export default class EditedLineupValidatorClassicBuilder extends BaseLineupValidatorBuilder {
    getInterface({incomingValues = {}}) {
        const {sportConfig, lineupPlayers} = incomingValues;

        return this.getMaxPlayersFromOneTeamValidator(sportConfig, lineupPlayers);
    }
}
